// extracted by mini-css-extract-plugin
export default {"container":"jq-z","brandName":"kq-z","productName":"lq-z","productNamePdpEnhancements":"mq-z","breakLongProductName":"nq-z"};